<template>
   <section class="discover_us ">
        <v-container>
        <v-row>
         <v-col
         cols="12"
         sm="12"
         md="6"
         >
           <v-carousel
             :cycle="true"
             :show-arrows-on-hover="true"
             hide-delimiter-background
             height="300"
             class="rounded-lg"
             >
                <v-carousel-item
                 v-for="(carousel, index) in carousels" :key="index"
                 :src='require(`@/assets/${carousel.img}`)'
                 >
                    
                </v-carousel-item>
            </v-carousel>
         </v-col>
         <v-col
         cols="12"
         sm="12"
         md="6"
         style="height:300px"
         class="d-flex justify-center flex-column"
         >
         <h3 class="text-capitalize h1 mb-3" style="font-size:18pt">{{$t("aboutUs.discoverUs")}}</h3>
         <p class="grey--text darken-5">{{$t("aboutUs.discoverUsText")}}</p>
         </v-col>
        </v-row>
        </v-container>
    </section>
</template>

<script>
export default {
    name:'discover_us',
    data() {
        return {
            carousels:[
                {img:'spencer-davis-QdU9lnBB5RQ-unsplash.jpg'},
                {img:'pexels-pixabay-315755.jpg'}
                ]
        }
    },
}
</script>

